import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useIsMobileDevice } from '../../../../hooks';
import { TDispatch } from '../../../../redux';
import { inputAuctionBet } from '../../../../redux/reducers';
import { selectCurrentBet, selectNextServiceCost, selectStepBet } from '../../../../selectors/auction';
import { selectBetInputError, selectBetPositionErrorCode } from '../../../../selectors/betPosition';
import { BetInputDesktop } from './BetInput.desktop';
import { BetInputMobile } from './BetInput.mobile';
import { trackBetChange } from './BetInput.tracking';
import { BET_MAX_LENGTH } from './constants';
import { formatBet, getNextLevelServiceMessage, getBetInputPlaceholder, parseBet } from './utils';

export const BetInputContainer = () => {
  const isMobile = useIsMobileDevice();

  const currentBet = useSelector(selectCurrentBet);
  const stepBet = useSelector(selectStepBet);
  const error = useSelector(selectBetInputError);
  const nextServiceCost = useSelector(selectNextServiceCost);
  const errorCode = useSelector(selectBetPositionErrorCode);

  const formattedBet = formatBet(currentBet);
  const message = getNextLevelServiceMessage({ nextServiceCost, isRaiseServiceLevelEnabled: !errorCode });
  const placeholder = getBetInputPlaceholder(stepBet);

  const dispatch = useDispatch<TDispatch>();

  const handleChange = React.useCallback(
    (_, value: string) => {
      if (value.length > BET_MAX_LENGTH) {
        return;
      }

      const parsedBet = parseBet(value);

      if (parsedBet !== currentBet) {
        dispatch(inputAuctionBet(parsedBet));

        trackBetChange();
      }
    },
    [currentBet, dispatch],
  );

  if (isMobile) {
    return (
      <BetInputMobile
        value={formattedBet}
        placeholder={placeholder}
        error={error}
        message={message}
        onChange={handleChange}
      />
    );
  }

  return (
    <BetInputDesktop
      value={formattedBet}
      placeholder={placeholder}
      error={error}
      message={message}
      onChange={handleChange}
    />
  );
};
